import { Assemblage } from './assemblage.model';
import { Contenant } from './contenant.model';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import * as moment from 'moment';
import { Cepage } from './cepage.model';
import { DataIdArrayConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Produit } from '../../habilitation/models/produit.model';
import { Site } from './site.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class SaisieConditionnement {
    static jsonMap = {
        idMouvement: { key: 'idMouvement', optional: true },
        codeProduit: { key: 'codeProduit', optional: true, default: '' },
        date: { key: 'date', converter: new DateConverter(), optional: true },
        logement: { key: 'logement', optional: true, default: '' },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        volume: { key: 'volume' },
        idSite: { key: 'idSite' },
        assemblages: { key: 'assemblages', converter: new (ArrayClassConverterFactory.build(Assemblage))(), optional: true, default: () => [] },
        contenants: { key: 'contenants', converter: new (ArrayClassConverterFactory.build(Contenant))(), optional: true, default: () => [] },
        cepages: { key: 'idsCepages', converter: new (DataIdArrayConverterFactory.build(Cepage, 'cepages'))(), optional: true, default: () => [] },
        observations: { key: 'observation', optional: true, default: '' }
    };

    idMouvement: number;
    codeProduit: string;
    date: moment.Moment;
    logement: string;
    numeroLot: string;
    volume: number;
    idSite: number;
    assemblages: Assemblage[];
    contenants: Contenant[];
    cepages: Cepage[];
    observations: string;

    produit: Produit;
    site: Site;
    idOperateur: number;
}
